<template>
  <a href="#0" aria-label="Search site" class="search-btn">
    <Icon />
    <span class="sr-only">Open Search</span>
  </a>
</template>

<script>
import Icon from "../Svgs/Icons/MagnifyingGlassIcon.vue";

export default {
  components: {
    Icon,
  },
};
</script>

<style></style>
